export const append = (node, childNode) => {
    node.appendChild(childNode);
    return {
        destroy: () => { }
    };
};
